import { FiChevronRight } from "react-icons/fi";

interface LoadMoreCardProps {
	isLoading: boolean;
	remaining: number;
	onClick: () => void;
}

export const LoadMoreCard: React.FC<LoadMoreCardProps> = ({
	onClick,
	isLoading,
	remaining,
}) => {
	return (
		<button
			type="button"
			onClick={onClick}
			disabled={isLoading}
			className="flex min-w-[200px] flex-shrink-0 cursor-pointer flex-col items-center justify-center gap-2 rounded-lg border-2 border-dashed border-gray-300 p-6 text-gray-500 transition-colors hover:border-blue-400 hover:text-blue-500 disabled:cursor-not-allowed disabled:opacity-50"
		>
			{isLoading ? (
				<div className="h-5 w-5 animate-spin rounded-full border-2 border-gray-300 border-t-blue-500" />
			) : (
				<FiChevronRight size={24} />
			)}
			<span className="text-sm font-medium">
				{isLoading ? "Loading..." : `Load More (${remaining})`}
			</span>
		</button>
	);
};
